import { colors, fonts, frames, icons, useMediaQuery } from "../../Styles/index";
import "../../Translations/index";
import { Pages } from "../Routers/CloudPanel/systemMenu_Router";
import { StyleObject } from "styletron-react";
import { useEffect, useMemo } from "react";
import { useAppSelector } from "../../Store";
import { Graph_QL } from "../../Services";
import { useSystem } from "../../Services/Agrisys_GqlDataCaller/SystemCalls/useSystem";

// TODO
import { CoreNavLink } from "../../Components/BaseComponents/coreNavLink";
import { NavLinkTypes } from "../../Definitions/navLinkTypes";

interface SystemMenu_Props {
  overrides?: {
    gridArea?: string;
  };
}

export default function SystemMenu({ overrides }: SystemMenu_Props) {
  const mobile = useMediaQuery(`(max-width: 1000px)`);
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { call: getSystemsInfo, data: systemsState } = useSystem(connection);

  useEffect(() => {
    getSystemsInfo({}, connection);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _Root = useMemo<StyleObject>(() => {
    return Object.assign(
      {} as StyleObject, //default stlye
      overrides && overrides.gridArea ? { gridArea: overrides.gridArea } : {}
    );
  }, [overrides]);

  // Systems from db
  // const systems = useMemo(() => systemsState && systemsState[domain]?.data, [domain, systemsState]);

  // TODO: Fjern Weaner Unit og Sow Unit når stemtype 2 og 3 eksisterer i db
  const systems = useMemo(() => {
    const original = systemsState && systemsState[domain]?.data || [];
  
    const manualSystems = [
      { name: "Weaner Unit", systemId: 2, systemType: 2 },
      { name: "Sow Unit", systemId: 3, systemType: 3 }
    ];
  
    return [...original, ...manualSystems];
  }, [domain, systemsState]);

  const systemTypeToLabel: Record<number, string> = {
    1: "Freeda Location Feeder",
    2: "AutoPig",
    3: "Freeda ESF Walk Through"
  };
  
  const systemTypeToIcon: Record<number, string> = {
    1: icons.freedaLF,
    2: icons.autoPig,
    3: icons.freedaESF_WalkThrough
  };
  
  const systemTypeToPage: Record<number, Pages> = {
    1: Pages.freeda_lf,
    2: Pages.autopig,
    3: Pages.freeda_esf
  };

  // if (!systems) return null;

  return (
    <frames.SystemMenu $style={_Root}>
      {!systems ? ( <p style={{...fonts.fontsize4, ...fonts.paragraph, color: colors.greyLightTertiary, textAlign: "center"}}>No Systems Found</p> ) : ( // TODO Translate
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "start", gap: "5px", width: "100%" }}> 
          {systems.map(system => {
            const page = systemTypeToPage[system?.systemType];
            const systemId = system.systemId;
            const systemName = system.name;
            const iconSrc = systemTypeToIcon[system.systemType];
            const toPath = `/${page}/${systemId}`;

            return (
              <CoreNavLink
                content={systemName}
                subContent={systemTypeToLabel[system.systemType]}
                navLinkType={NavLinkTypes.systemNavLink}
                path={toPath}
                endPath={false}
                icon={iconSrc}
                overrides={{
                }}
              />
            );
          })}
        </div>
      )}
    </frames.SystemMenu>
  );
}